import { Controller } from "@hotwired/stimulus"
import { startIcons } from "../import_lucid.js"

export default class extends Controller {
  static targets = [ "modal", "modalBg", "scheduleButton", "scheduleSummary" ]

  connect() {
    this.updateButtonText()
    this.updatePositions()
  }

  openSchedule(event) {
    event.preventDefault()
    this.modalBgTarget.classList.remove('hidden')
    this.modalTarget.classList.remove('hidden')
  }

  closeSchedule(event) {
    event.preventDefault()
    this.modalBgTarget.classList.add('hidden')
    this.modalTarget.classList.add('hidden')
    this.updateButtonText()
  }

  updateButtonText() {
    const input = this.element.querySelector('input[name*="[schedule]"]')
    const summaryTarget = this.hasScheduleSummaryTarget ? this.scheduleSummaryTarget : null

    if (input && input.value && input.value.trim() !== "") {
      if (summaryTarget) {
        summaryTarget.dataset.cronSummaryCronValue = input.value
      }
      if (this.hasScheduleButtonTarget) {
        this.scheduleButtonTarget.classList.add("bg-indigo-50", "text-indigo-700", "border-indigo-200")
        this.scheduleButtonTarget.classList.remove("text-gray-700", "border-gray-300")
      }
    } else {
      if (summaryTarget) {
        summaryTarget.dataset.cronSummaryCronValue = ""
      }
      if (this.hasScheduleButtonTarget) {
        this.scheduleButtonTarget.classList.remove("bg-indigo-50", "text-indigo-700", "border-indigo-200")
        this.scheduleButtonTarget.classList.add("text-gray-700", "border-gray-300")
      }
    }
  }

  updatePositions() {
    const wrappers = this.element.querySelectorAll(".nested-form-wrapper")
    let currentPosition = 1
    wrappers.forEach((wrapper) => {
      startIcons(wrapper)
      
      const destroyInput = wrapper.querySelector("input[name*='_destroy']")
      const isDeleted = destroyInput && destroyInput.value === "1"

      if (!isDeleted && wrapper.style.display !== 'none') {
        const positionInput = wrapper.querySelector(".step-position")
        if (positionInput) {
          positionInput.value = currentPosition++
        }
      }
    })
  }

  removeStep(event) {
    event.preventDefault()
    const button = event.currentTarget
    const wrapper = button.closest(".nested-form-wrapper")
    const card = wrapper.querySelector(".step-card")
    const badge = wrapper.querySelector(".pending-badge")
    const iconContainer = button.querySelector('svg') || button.querySelector('i')

    if (wrapper.dataset.newRecord === "true") {
      wrapper.remove()
      this.updatePositions()
      return
    }

    const destroyInput = wrapper.querySelector("input[name*='_destroy']")
    if (!destroyInput) return

    const isDeleted = destroyInput.value === "1"

    if (isDeleted) {
      // RESTORE
      destroyInput.value = "0"

      // UI Reset
      card.classList.remove("bg-red-50", "border-red-200")
      card.classList.add("bg-white", "border-gray-200")
      
      // Re-enable inputs
      wrapper.querySelectorAll("input, select").forEach(el => {
          if (el.type !== 'hidden') {
              el.style.pointerEvents = "auto"
              el.style.opacity = "1"
          }
      })

      badge.classList.add("hidden")

      // Change Icon to Trash
      if (iconContainer) {
         const i = document.createElement("i")
         i.setAttribute("data-lucide", "trash-2")
         i.classList.add("w-5", "h-5")
         iconContainer.replaceWith(i)
         startIcons(button)
      }
      
      button.classList.remove("text-indigo-600", "hover:text-indigo-700", "hover:bg-indigo-50")
      button.classList.add("text-gray-400", "hover:text-red-500", "hover:bg-red-50")
      button.setAttribute("aria-label", button.getAttribute("aria-label").replace(/^Restore /, "Remove "))

    } else {
      // DELETE
      destroyInput.value = "1"

      // UI Delete State
      card.classList.remove("bg-gray-50", "border-gray-200")
      card.classList.add("bg-red-50", "border-red-200")
      
      // Disable inputs visually
      wrapper.querySelectorAll("input, select").forEach(el => {
          if (el.type !== 'hidden') {
              el.style.pointerEvents = "none"
              el.style.opacity = "0.4"
          }
      })

      badge.classList.remove("hidden")

      // Change Icon to Undo/Redo
      if (iconContainer) {
         const i = document.createElement("i")
         i.setAttribute("data-lucide", "rotate-cw")
         i.classList.add("w-5", "h-5")
         iconContainer.replaceWith(i)
         startIcons(button)
      }

      button.classList.remove("text-gray-400", "hover:text-red-500", "hover:bg-red-50")
      button.classList.add("text-indigo-600", "hover:text-indigo-700", "hover:bg-indigo-50")
      button.setAttribute("aria-label", button.getAttribute("aria-label").replace(/^Remove /, "Restore "))
    }
    this.updatePositions()
  }
}
